module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "session-modal d-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "session-box"
  }, [_c('div', {
    staticClass: "page-title"
  }, [(!_vm.noMoreTime) ? _c('span', [_vm._v("This booking is almost yours!")]) : _c('span', [_vm._v("Session Timeout!")])]), _vm._v(" "), (!_vm.noMoreTime) ? _c('div', {
    staticClass: "session-msg"
  }, [_vm._v("\n      You're so close to securing this booking. Go ahead and complete the last few details to make it yours\n      "), (false) ? _c('div', [_vm._v("\n        Your session will expire in "), _vm._m(0), _vm._v(".\n        "), _c('br'), _vm._v("\n        Do you need more time?\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.noMoreTime) ? _c('div', {
    staticClass: "op-btn btn-md btn-block btn-success",
    on: {
      "click": _vm.initRenewSession
    }
  }, [_c('span', [_vm._v("Continue Booking")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-secondary",
    on: {
      "click": _vm.sendMeBack
    }
  }, [(!_vm.noMoreTime) ? _c('span', [_vm._v("NO, Bring me to home page")]) : _c('span', [_vm._v("Close")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    attrs: {
      "id": "timeLeft"
    }
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d6d03c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6d03c2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/SessionModal.vue
// module id = 2047
// module chunks = 0